import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const TOucin = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if (ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="UNIDADE DE CUIDADOS INTERMEDIÁRIO NEONATAL" />
                    <div style={{ textAlign: "left" }}>
                        <HeaderVerde texto="UCIN Convencional" />
                        <Select label="Tipo da Equipe" nome="toucintipoequipe" modulo={modulo} index={n}
                            widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["Equipe Própria", "Híbrida", "Terceirizada"]} />
                        <Input label="Nº de leitos" nome="ucinconv" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Nº de Pacientes Durante a Fiscalização" nome="ucinconpac" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Nº de Pacientes Assistidos" nome="ucinconvassistido" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Profissionais que assistem no setor" nome="ucinconvterap" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="30vw" widthMobile="80vw" marginR="3vw" />

                        <HeaderVerde texto="UCIN Canguru" />
                        <Input label="Nº de leitos" nome="ucincanguleitos" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Nº de Pacientes Durante a Fiscalização" nome="ucincangupac" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Nº de Pacientes Assistidos" nome="ucincanguassist" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Profissionais que assistem no setor" nome="ucincanguterap" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="30vw" widthMobile="80vw" marginR="3vw" />

                        <HeaderVerde texto="UCIN Neonatal" />
                        <Input label="Nº de leitos" nome="ucinneoleitos" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Nº de Pacientes Durante a Fiscalização" nome="ucinneopac" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Nº de Pacientes Assistidos" nome="ucinneoassist" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Profissionais que assistem no setor" nome="ucinneoterap" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="30vw" widthMobile="80vw" marginR="3vw" />
                    </div>
                    <div style={{ textAlign: "left" }}>
                        <Select label="Está garantida a assistência da Terapia Ocupacional ao paciente(CONFORME RDC 07/2010 ANVISA)" nome="ucin0710" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="25vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Observacoes widthWeb="83vw" widthMobile="80vw" modulo={modulo} index={n} nome="observacoes" />
                    </div>
                </Caixa >
            )
        }
        return partes
    }
}
export default TOucin